import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Input } from '../../common/Forms/Input/Input';

export const VehicleTypeFormPanel = ({
  editingVehicleTypeId,
  vehicleClassOptionsList,
  register,
  errors,
  onSubmit,
  onCancel,
}) => (
  <>
    <h4 className="parameters-page__create-title">
      {editingVehicleTypeId
        ? 'Editar tipo de vehículo'
        : 'Crear nuevo tipo de vehículo'}
    </h4>
    <div className="parameters-page__create-fields parameters-page__create-fields--city">
      <div
        className="row"
        style={{ width: '100%', alignItems: 'flex-start' }}
      >
        {!editingVehicleTypeId && (
          <Input
            bootstrap="col-12 col-md-3"
            label="Clase de vehículo *"
            type="select"
            name="classId"
            options={vehicleClassOptionsList}
            register={register}
            placeholder=""
            errors={errors?.classId?.message}
          />
        )}
        <Input
          bootstrap="col-12 col-md-3"
          label="Nombre del tipo *"
          type="text"
          name="description"
          register={register}
          placeholder="Ej: Sedan, SUV, Pickup, etc."
          errors={errors?.description?.message}
        />
        <div
          className="col-12 col-md-auto buttons-center-container"
          style={{ marginTop: '32px' }}
        >
          <ActionButton
            label={editingVehicleTypeId ? 'Guardar cambios' : 'Guardar'}
            action={onSubmit}
          />
          <AltButton label="Cancelar" action={onCancel} />
        </div>
      </div>
    </div>
  </>
);
